<template>
  <b-modal :title="asset.name"
           v-model="showModal"
           v-if="asset"
           :hide-footer="!footerHTML"
           :footer-class="footerClass"
           no-fade
           size="lg"
           centered
           scrollable>
    <div class="d-flex justify-content-between">
      <div class="flex-grow-1 d-flex justify-content-center">
        <video-player v-if="isVideo && false"
                      :thumb-url="asset.thumb_url"
                      :url="asset.media_thumb_url"/>
        <b-img v-else :src="asset.watermark_medium_url" fluid/>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="w-100" v-html="footerHTML"></div>
    </template>
  </b-modal>
</template>

<script>
import VideoPlayer from "./VideoPlayer.vue";

export default {
  props: ['footerHTML', 'footerClass', 'asset'],

  model: {
    prop: 'asset',
    event: 'change'
  },

  data() {
    return {
      showModal: false
    }
  },

  watch: {
    asset(val) {
      if (val) {
        this.showModal = true
      }
    },

    showModal(val) {
      if (!val) {
        this.$emit('change', null)
      }
    }
  },

  components: {VideoPlayer},

  computed: {
    isVideo() {
      if (!this.asset) return false

      return this.asset.asset_type === "Video" || this.asset.type === "Video"
    }
  },
}
</script>